
<ngb-alert type="success" class="alert-dismissible alert-solid alert-label-icon fade show custom-alert">
    <i class="ri-notification-off-line label-icon"></i>{{message}}
</ngb-alert>
    
